<aside #mainSidebar class="main-sidebar sidebar-dark-primary elevation-4">
  <!-- Brand Logo -->
  
    <!--<Strong class="brand-text font-weight-bold">OrangeEye</Strong> &nbsp;-->
    <!--<span class="badge badge-warning" style="font-size:small">Beta</span>-->

  <div class="row">
    <div class="col-10">
      <a [routerLink]="['/']" class="brand-link">
        <img src="../../../../assets/img/OrangEyeLogo.png"
             alt="/"
             style="height:80px;width:80px" /></a>
    </div>
    <div class="col-2">
      <button pButton *ngIf="isMobile" type="button" icon="pi pi-chevron-left" (click)="showHideSideMenu()"></button>
    </div>
  </div>

  <!-- Sidebar -->
  <div class="sidebar">

    <!-- Sidebar Menu -->
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
        <!-- Add icons to the links using the .nav-icon class
        with font-awesome or any other icon font library -->
        <li class="nav-item">
          <a class="nav-link active">
            <i class="nav-icon fas fa-user-tie"></i>
            <p>
              {{user}}
            </p>
          </a>
          <hr />
        </li>

        <li class="nav-item has-treeview menu-open">
          <a href="#" class="nav-link active">
            <i class="nav-icon fas fa-user-check nav-icon"></i>
            <p>
              Account
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item ">
              <a class="nav-link" [routerLink]="['/branches']">
                <i class="fa fa-map-marker nav-icon "></i>
                <p>
                  &nbsp;Branches
                </p>
              </a>
            </li>
            <li class="nav-item ">
              <a class="nav-link" [routerLink]="['/total-graph']">
                <i class="fas fa-chart-bar nav-icon"></i>
                <p>
                  &nbsp;Total Graphs
                </p>
              </a>
            </li>
            <li class="nav-item ">
              <a class="nav-link" [routerLink]="['/contact-us']">
                <i class="fas fa-envelope nav-icon"></i>
                <p>
                  &nbsp;Contact Us
                </p>
              </a>
            </li>

          </ul>




        <li class="nav-item has-treeview menu-open">
          <a href="#" class="nav-link active">
            <i class="nav-icon fa fa-map-marker"></i>
            <p>
              Branches
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>

          <ul class="nav nav-treeview" [ngClass]="{ 'overlay': loader }">

            <div class="overlay dark load" *ngIf="loader" style="width: 100%; height: 550px;">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>

            <li *ngFor="let item of fullMenu; let i = index" class="nav-item">
              <!--href="#/{{item.link}}"-->
              <a class="nav-link" [routerLink]="item.link">
                <!--"['/branches/',account?.ucid]"-->
                <p style="font-size:small" pTooltip="{{item.name}}">
                  &nbsp;
                  <i *ngIf="item.isMonitored" class="fas fa-desktop {{getViewClass(item)}}" pTooltip="{{getStatusName(item)}}"></i>
                  <i *ngIf="!item.isMonitored" class="fas fa-times-circle" pTooltip="{{getStatusName(item)}}"></i>
                  &nbsp; {{clipstring(item.name)}}
                </p>
              </a>
            </li>



            <li>
              <div class=" col-12 " style="text-align:center">
                <p-button class="mb-3"
                          icon="fas fa-angle-left"
                          (click)="previous()"
                          [loading]="loader"
                          [disabled]="isFirst()">
                </p-button>
                <p-button class="mb-3"
                          icon="fas fa-recycle"
                          [loading]="loader"
                          (click)="reset()">

                </p-button>
                <p-button class="mb-3"
                          icon="fas fa-angle-right"
                          (click)="next()"
                          [loading]="loader"
                          [disabled]="isLast()">
                </p-button>
              </div>
            </li>




          </ul>

        </li>

      </ul>

    </nav>
    <!-- /.sidebar-menu -->
  </div>
  <!-- /.sidebar -->
</aside>
